<template>
  <div>
    <div class="body">
      <a class="card-education education"  style="cursor: pointer"  @click="$router.push({name: 'SelectAffiliateProductsForSale'})">
        <div class="overlay"></div>
        <div class="circle">

          <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="29 14 71 76" height="76px" width="71px">

            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g transform="translate(30.000000, 14.000000)" fill-rule="evenodd" fill="none" stroke-width="1" stroke="none" id="Group">
              <g fill="#D98A19" id="Group-8">
                <g id="Group-7">
                  <g id="Group-6">
                    <path id="Fill-1" d="M0,0 L0,75.9204805 L69.1511499,75.9204805 L0,0 Z M14.0563973,32.2825679 L42.9457663,63.9991501 L14.2315268,63.9991501 L14.0563973,32.2825679 Z"></path>
                  </g>
                </g>
              </g>
              <g stroke-linecap="square" stroke="#FFFFFF" transform="translate(0.000000, 14.114286)" id="Group-20">
                <path id="Line" d="M0.419998734,54.9642857 L4.70316223,54.9642857"></path>
                <path id="Line" d="M0.419998734,50.4404762 L4.70316223,50.4404762"></path>
                <path id="Line" d="M0.419998734,45.9166667 L4.70316223,45.9166667"></path>
                <path id="Line" d="M0.419998734,41.3928571 L2.93999114,41.3928571"></path>
                <path id="Line" d="M0.419998734,36.8690476 L4.70316223,36.8690476"></path>
                <path id="Line" d="M0.419998734,32.3452381 L4.70316223,32.3452381"></path>
                <path id="Line" d="M0.419998734,27.8214286 L4.70316223,27.8214286"></path>
                <path id="Line" d="M0.419998734,23.297619 L2.93999114,23.297619"></path>
                <path id="Line" d="M0.419998734,18.7738095 L4.70316223,18.7738095"></path>
                <path id="Line" d="M0.419998734,14.25 L4.70316223,14.25"></path>
                <path id="Line" d="M0.419998734,9.72619048 L4.70316223,9.72619048"></path>
                <path id="Line" d="M0.419998734,5.20238095 L2.93999114,5.20238095"></path>
                <path id="Line" d="M0.419998734,0.678571429 L4.70316223,0.678571429"></path>
              </g>
            </g>
          </svg>
        </div>
        <p>انتخاب کالا</p>
      </a>

    </div>
  </div>
</template>
<script>

export default {
  name: "BusinessProductSelectCard",
  mixins: [],
  data() {
    return {
    };
  },
  computed: {
    items() {
      return [];
    },
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.education {
  --bg-color: #ffd861;
  --bg-color-light: #ffeeba;
  --text-color-hover: #4C5656;
  --box-shadow-color: rgba(255, 215, 97, 0.48);
}

.card-education {
  width: 220px;
  height: 321px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 0 14px 26px rgba(0,0,0,0.04);
  transition: all 0.3s ease-out;
  text-decoration: none;
}

.card-education:hover {
  transform: translateY(-5px) scale(1.005) translateZ(0);
  box-shadow: 0 24px 36px rgba(0,0,0,0.11),
  0 24px 46px var(--box-shadow-color);
}

.card-education:hover .overlay {
  transform: scale(4) translateZ(0);
}

.card-education:hover .circle {
  border-color: var(--bg-color-light);
  background: var(--bg-color);
}

.card-education:hover .circle:after {
  background: var(--bg-color-light);
}

.card-education:hover p {
  color: var(--text-color-hover);
}

.card-education:active {
  transform: scale(1) translateZ(0);
  box-shadow: 0 15px 24px rgba(0,0,0,0.11),
  0 15px 24px var(--box-shadow-color);
}

.card-education p {
  font-size: 17px;
  color: #4C5656;
  margin-top: 30px;
  z-index: 1000;
  transition: color 0.3s ease-out;
}

.circle {
  width: 131px;
  height: 131px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid var(--bg-color);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease-out;
}

.circle:after {
  content: "";
  width: 118px;
  height: 118px;
  display: block;
  position: absolute;
  background: var(--bg-color);
  border-radius: 50%;
  transition: opacity 0.3s ease-out;
}

.circle svg {
  z-index: 10000;
  transform: translateZ(0);
}

.overlay {
  width: 118px;
  position: absolute;
  height: 118px;
  border-radius: 50%;
  background: var(--bg-color);
  top: 70px;
  left: 50px;
  z-index: 0;
  transition: transform 0.3s ease-out;
}
</style>
